'use strict';

module.exports = require('./lib')



/*****************
 ** WEBPACK FOOTER
 ** ../~/promise/index.js
 ** module id = 41
 ** module chunks = 0
 **/